import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from "react";
const TelephoneIcon = _ref => {
  let {
      size = "20",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({}, attributes, {
    width: size,
    height: size,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), __jsx("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M1.88477 0.649259C2.62689 -0.092855 3.85149 -0.0166136 4.49583 0.811818L6.28954 3.11801C6.6187 3.54122 6.73502 4.09227 6.60498 4.61241L6.05772 6.80148C5.99994 7.03258 6.06766 7.27706 6.2361 7.44551L8.69268 9.90208C8.86113 10.0705 9.1056 10.1382 9.33671 10.0805L11.5258 9.5332C12.0459 9.40317 12.597 9.51949 13.0202 9.84865L15.3264 11.6424C16.1548 12.2867 16.231 13.5113 15.4889 14.2534L14.455 15.2873C13.7153 16.0271 12.6089 16.3519 11.5778 15.9893C9.01754 15.0892 6.61438 13.6156 4.56849 11.5697C2.5226 9.5238 1.04895 7.12064 0.148838 4.56043C-0.213682 3.52931 0.11113 2.4229 0.85085 1.68318L1.88477 0.649259Z",
    fill: color
  }));
};
export default TelephoneIcon;